<div
  class="prefooter-row"
  [class]="orientation"
  #prefooter
  *ngIf="!isLoading; else loadingPrefooter"
>
  <!-- Image Section -->
  <div
    class="prefooter-image-col"
    [class.static-image]="staticImage"
    [class.image-background]="imageBackground"
    [class.no-badge]="!showBadge"
  >
    <div
      class="img"
      [ngClass]="{ 'img--no-play-button': !showPlayButton }"
      [style.backgroundColor]="imageBackground || 'transparent'"
    >
      <hdi-modal-function
        *ngIf="showPlayButton; else noPlayButton"
        [type]="ModalFunctionType.VIDEO"
        [imageSrc]="imageSrc"
        [imageAlt]="imageAlt"
        [imageTitle]="imageTitle"
        [videoTitle]="videoTitle"
        [videoSrc]="videoSrc"
        [videoId]="videoId"
        [thumbnailSrc]="thumbnailSrc"
        [showIcon]="showPlayButton"
      ></hdi-modal-function>
      <ng-template #noPlayButton>
        <hdi-image
          *ngIf="imageSrc"
          [src]="imageSrc"
          [alt]="imageAlt"
          [title]="imageTitle"
        ></hdi-image>
      </ng-template>
      <div
        *ngIf="showBadge"
        class="prefooter-image-col-badge"
        [class]="orientation"
      >
        <hdi-image *ngIf="badgeContent === MediaType.IMAGE" [src]="badgeSrc" />
        <hdi-icon
          *ngIf="badgeContent === MediaType.ICON"
          [iconName]="badgeIcon"
          [color]="Colors.WHITE"
        />
      </div>
    </div>
  </div>
  <!-- End Image Section -->
  <!-- Text Section -->
  <div
    class="prefooter-text-col"
    [ngClass]="{ 'prefooter-text-col--loader': isLoading }"
  >
    <h2 *ngIf="headline">{{ headline }}</h2>
    <div *ngIf="innerHTMLText" [innerHTML]="innerHTMLText"></div>
    <div
      *ngIf="clickableCategory === 'button' || clickableCategory === 'link'"
      class="prefooter-text-col-buttons"
      [class]="buttonsFlex"
    >
      <!-- Clickable Button / Link -->
      <ng-container *ngIf="clickableCategory === 'button'">
        <hdi-button
          [type]="buttonType"
          [label]="clickableText | capitalize"
          [iconName]="clickableIcon"
          [isWithoutIcon]="true"
          [title]="clickableTitle"
          [disabled]="!isActive"
          (clickEvent)="handleClick($event)"
        ></hdi-button>
      </ng-container>
      <hdi-link
        *ngIf="clickableCategory === 'link'"
        [type]="linkType"
        [href]="clickableHref"
        [title]="clickableTitle"
        [disabled]="!isActive"
        [hrefType]="
          hrefType === HrefType.ANGULAR_ROUTE
            ? HrefType.ANGULAR_ROUTE
            : hrefType === HrefType.OPEN_MODAL_VIDEO
              ? HrefType.OPEN_MODAL_VIDEO
              : HrefType.EXTERNAL
        "
        [video]="clickableVideo"
        [label]="clickableText | capitalize"
      ></hdi-link>
      <!-- Ende Clickable Button / Link -->
      <!-- Optional Link -->
      <hdi-link
        *ngIf="optionalLinkText && optionalLinkHref"
        [type]="optionalLinkType"
        [href]="optionalLinkHref"
        [label]="optionalLinkText | capitalize"
        [video]="optionalLinkVideo"
        [title]="optionalLinkTitle"
        [hrefType]="
          optionalHrefType === HrefType.ANGULAR_ROUTE
            ? HrefType.ANGULAR_ROUTE
            : optionalHrefType === HrefType.OPEN_MODAL_VIDEO
              ? HrefType.OPEN_MODAL_VIDEO
              : HrefType.EXTERNAL
        "
      ></hdi-link>
      <!-- Ende Optional Link -->
    </div>
  </div>
  <!-- End Text Section -->
</div>

<!-- Loading Placeholder -->
<ng-template #loadingPrefooter>
  <hdi-prefooter-loader></hdi-prefooter-loader>
</ng-template>
